<template>
  <d-container :paddingless-mobile="true">
    <d-card>
      <d-card-row>
        <h2 class="title is-6">
          {{ $t('update_information') }}
        </h2>
      </d-card-row>
      <v-form
        :data="form"
        format="formData"
        :url="$laravel.route('api.users.update', {user: user.id})"
        method="patch"
        @success="success()"
      >
        <d-card-row>
          <v-input
            v-model="form.name"
            name="name"
          />
          <v-input
            v-model="form.email"
            name="email"
          />
        </d-card-row>

        <!-- Profile photo -->
        <d-card-row>
          <label class="label mb-2">
            {{ $t("profile_picture").capitalize() }}
          </label>
          <figure
            v-if="profilePicture"
            class="image is-128x128 mb-4"
          >
            <img
              class="is-rounded profile-picture-preview"
              :src="profilePicture"
            >
          </figure>

          <b-field>
            <b-upload
              v-model="form.avatar"
              :multiple="false"
              drag-drop
              type="is-primary"
              accept="image/*"
              @input="onProfilePictureUpload"
            >
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon
                      icon="upload"
                      size="is-large"
                    />
                  </p>
                  <p>{{ $t("drop_or_click_to_upload") }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>
        </d-card-row>

        <d-card-row>
          <v-input-select
            v-model="form.locale"
            name="locale"
          >
            <option
              v-for="(locale, code) in $laravel.app.locales"
              :key="code"
              :value="code"
            >
              {{ locale }}
            </option>
          </v-input-select>
        </d-card-row>

        <d-card-row>
          <button
            class="button is-primary"
            type="submit"
          >
            {{ $t('save') }}
          </button>
        </d-card-row>
      </v-form>
    </d-card>
  </d-container>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      profilePicture: this.user.avatar_url || null,
      form: {
        name: this.user.name,
        email: this.user.email,
        locale: this.user.locale,
        avatar: null
      }
    };
  },
  methods: {
    onProfilePictureUpload (file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.profilePicture = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    success () {
      this.$refresh();
    }
  }
};
</script>

<style scoped>
.profile-picture-preview {
  width: 128px;
  height: 128px;
  object-fit: cover;
}
</style>
